
import {ComponentSingleStyleConfig} from '@chakra-ui/theme/dist/types/theme.types';

export const Button: ComponentSingleStyleConfig = {
  variants: {
    primary: {
      bg: 'blue.500',
      color: 'white',
      _hover: {
        bg: 'blue.600'
      }
    },
    secondary: {
      bg: 'transparent',
      borderWidth: '1px',
      borderColor: 'blue.500',
      color: 'blue.500',
      _hover: {
        bg: 'blue.50'
      }
    }
  }
};
